import React from "react";
import PaginationDiv from "modules/pagination/PaginationDiv";

function TableFooter(props) {
  const { paginationData, newPage } = props;

  return (
    <div className="mt-5">
      <PaginationDiv newPage={newPage} paginationData={paginationData} />
    </div>
  );
}

export default TableFooter;
